/* --------------------------------
[JSファイルの説明]
・gulpで scripts.json の libs の各ファイルを連結し、 /js/libs.js に書き出している
・gulpで scripts.json の scripts の各ファイルを連結＆圧縮し、 /js/scripts.js に書き出している
・HTMLでは上記の libs.js と scripts.js を読み込んでいる
・もしもgulpの環境が無くて更新が困難な場合は、書き出したJSは無視して scripts.json の各ファイルをHTMLで直接読み込んでも動作は可能
-------------------------------- */

// スクロールバーを除いたウィンドウ幅をCSSのカスタムプロパティに設定
const setVw = function() {
  const vw = document.documentElement.clientWidth;
  document.documentElement.style.setProperty('--vw', `${vw}px`);
}
window.addEventListener('DOMContentLoaded', setVw);
window.addEventListener('resize', setVw);

//スライダー
$(function(){
  $('.home-kv__slick').each(function(index, el) {
    const $slider = $(this);

    $slider.slick({
      autoplay: true,
      autoplaySpeed: 3000,
      fade: false,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: false,
      dots: false
    });
  });
});

//スライダー
let $gSlider;
$(function(){
  $('.home-instagram__slick').each(function(index, el) {
    $gSlider = $(this);

    $gSlider.slick({
      autoplay: false,
      autoplaySpeed: 3000,
      fade: false,
      speed: 1000,
      pauseOnFocus: false,
      pauseOnHover: false,
      pauseOnDotsHover: false,
      arrows: true,
      dots: false
    });
  });
});

//aタグ スムーススクロール
$(function(){
  $('a[href^="#"]').click(function(){
    var speed = 500;
    var href= $(this).attr("href");
    var target = $(href == "#" || href == "" ? 'html' : href);
    var position = target.offset().top;

    position -= $('.l-header').innerHeight();

    $('.p-hd__menuSP button').removeClass('is-on');
    $('.p-hd__navSP').removeClass('is-on');

    let action = $(this).attr('data-action');
    if(action) {
      if(action == 'instagram1') {
        $gSlider.slick('slickGoTo', 0);
      }
      if(action == 'instagram2') {
        $gSlider.slick('slickGoTo', 1);
      }
      if(action == 'instagram3') {
        $gSlider.slick('slickGoTo', 2);
      }
      if(action == 'media1') {
        $('.home-media__tabBtns ul li button[data-num="1"]').trigger('click');
      }
      if(action == 'media2') {
        $('.home-media__tabBtns ul li button[data-num="2"]').trigger('click');
      }
      if(action == 'media3') {
        $('.home-media__tabBtns ul li button[data-num="3"]').trigger('click');
      }
    }

    $("html, body").animate({scrollTop:position}, speed, "swing");
    return false;
  });
});

//フェード
$(function(){
  var fade = $('.u-fade, .js-fadeAni');

  fade.each(function(index, el) {
    var t = $(this);

    setTimeout(function(){
      $(window).on('resize scroll', function(event) {
        run();
      });

      run();
    }, 200);

    function run() {
      var winT = $(window).scrollTop();
      var winH = $(window).innerHeight();
      var winB = winT + winH;
      var tT = t.offset().top;
      var tH = t.innerHeight();
      var tB = tT + tH;

      var pointH = tT + 50;
      var pointSc = winB;
      var pointD = 200;

      var h = t.attr('data-fade-h');
      if(h) {
        pointH = tT + tH * h / 100;
      }

      var sc = t.attr('data-fade-sc');
      if(sc) {
        pointSc = winT + winH * sc / 100;
      }

      var d = t.attr('data-fade-delay');
      if(d) {
        pointD = d;
      }

      if(pointH < pointSc) {
        setTimeout(function(){
          t.addClass('is-fade');
          next();
        }, pointD);
      }
    }

    function next() {
      var nextStr = t.attr('data-fade-next-target');
      if(nextStr) {
        var nextArr = nextStr.split(' ');
        if(nextArr) {
          for (var i = 0; i < nextArr.length; i++) {
            var next = nextArr[i];
            var nextTar = $('[data-fade-next-id="' + next + '"]');
            if(nextTar[0]) {
              var nextDelay = t.attr('data-fade-next-delay');
              var delay = 200;
              if(nextDelay) {
                delay = parseInt(nextDelay);
              }

              var nextStep = t.attr('data-fade-next-step');
              var step = 200;
              if(nextDelay) {
                step = delay;
              }
              if(nextStep) {
                step = parseInt(nextStep);
              }

              nextTar.each(function(index, el) {
                var t2 = $(this);
                var step2 = step * index + delay;

                setTimeout(function(){
                  t2.addClass('is-fadeNext');
                  t2.attr('data-test', step2);
                }, step2);
              });
            }
          }
        }
      }
    }
  });
});

$(function(){
  $('.p-hd__menuSP button').each(function (index, element) {
    const $btn = $(this);
    const $nav = $('.p-hd__navSP');

    $btn.on('click', function () {
      $btn.toggleClass('is-on');
      $nav.toggleClass('is-on');
    });
  });
});

$(function(){
  $('.home-media__tabBtns').each(function (index, element) {
    const $btn = $(this).find('ul li button');
    const $con = $('.home-media__tabCon');

    $btn.on('click', function () {
      let index = parseInt($(this).attr('data-num')) - 1;

      $btn.removeClass('is-cr');
      $(this).addClass('is-cr');
      $con.hide().eq(index).stop().fadeIn(300);
    });
  });
});

//カウントダウン
$(document).ready(function() {

  // カウントダウンの終了日時を設定
  let countdownDate = new Date("2025-02-06T10:00:00");

  let x = setInterval(function() {
    run();
  }, 1000); // 1000ミリ秒ごとに更新

  run();

  function run() {
    // 現在の日時を取得
    let now = new Date();
    
    // カウントダウンまでの残り時間を計算
    let distance = countdownDate - now;

    // 残り時間を日数、時間、分、秒に変換
    let days = Math.floor(distance / (1000 * 60 * 60 * 24));
    let hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    let seconds = Math.floor((distance % (1000 * 60)) / 1000);

    // カウントダウンが終了した場合はメッセージを表示してタイマーを停止
    if (distance < 0) {
      clearInterval(x);
      $(".js-countDown").removeClass('is-show');
    } else {
      $(".js-countDown").addClass('is-show');
      // 残り時間を表示
      $(".js-countDownD").text(days);
      $(".js-countDownH").text(hours);
      $(".js-countDownM").text(minutes);
      $(".js-countDownS").text(seconds);
    }
  }
});